import "slick-carousel";

export default {
    apply($context) {
        $context.find("[data-slider]").slick({
            infinite: false,
            slidesToShow: 6,
            swipeToSlide: true,
            touchThreshold: 10,
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            }]
        });
    },
    destroy($context) {
        $context.find("[data-slider]").slick("unslick");
    }
};